export const extractUrlParams = (url: string = ''): string => url.replace(/.*?\?/, '');

export const getUrlParams = (url?: string): Map<string, string> => {
    let queryString: string = extractUrlParams(url || window.location.hash);
    let keyValPairs = [];
    let params = new Map<string, string>();

    if (queryString.length) {
        keyValPairs = queryString.split('&');
        for (const pairNum in keyValPairs) {
            const key = keyValPairs[pairNum].split('=')[0];
            if (!key.length) continue;
            const value = keyValPairs[pairNum].split('=')[1];
            params.set(key, value);
        }
    }
    return params;
};
